import * as types from '../constants/idpAdminActions';
import * as samlConstants from '../constants/samlConstants';
import * as messages from '../shared/messages';

const initialState = {
  errorMsg: null,
  parseUrlInProgress: false,
  importMetadata: null,
  idpUserAttributes: samlConstants.DEFAULT_USER_ATTRIBUTES,
  showModalImportUrl: false,
  applicationName: '',
  userFriendlyName: '',
  defaultSamlNameIdFormatEnum: samlConstants.UNSPECIFIED,
  selectedImportOption: samlConstants.IMPORT_FROM_URL,
  duplicate: null,
  downloadUrl: '',
  modalExpiredMetadataCertificateIsShown: false
};

export default function orgs(state = initialState, action = {}) {
  switch (action.type) {
    case types.PARSE_FROM_URL_START:
      return {
        ...state,
        errorMsg: null,
        parseUrlInProgress: true
      };
    case types.PARSE_FROM_URL_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        importMetadata: action.metadata.parsedMetadata,
        downloadUrl: action.metadata.parsedMetadata.downloadUrl,
        defaultSamlNameIdFormatEnum: action.metadata.parsedMetadata.samlNameIdFormats.filter(
            e => e.samlNameIdFormatEnum
                === state.defaultSamlNameIdFormatEnum).length
        > 0 ? state.defaultSamlNameIdFormatEnum
            : action.metadata.parsedMetadata.defaultSamlNameIdFormatEnum,
        selectedImportOption: samlConstants.IMPORT_FROM_URL,
        duplicate: action.metadata.duplicate,
        parseUrlInProgress: false,
      };
    case types.PARSE_FROM_URL_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg || messages.UNABLE_TO_PARSE_METADATA_URL_OR_XML,
        parseUrlInProgress: false,
        showModalImportUrl: true
      };
    case types.PARSE_FROM_XML_START:
      return {
        ...state,
        errorMsg: null,
        parseXmlInProgress: true
      };
    case types.PARSE_FROM_XML_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        importMetadata: action.metadata.parsedMetadata,
        downloadUrl: '',
        defaultSamlNameIdFormatEnum: action.metadata.parsedMetadata.samlNameIdFormats.filter(
            e => e.samlNameIdFormatEnum
                === state.defaultSamlNameIdFormatEnum).length
        > 0 ? state.defaultSamlNameIdFormatEnum
            : action.metadata.parsedMetadata.defaultSamlNameIdFormatEnum,
        selectedImportOption: samlConstants.IMPORT_FROM_FILE,
        duplicate: action.metadata.duplicate,
        parseXmlInProgress: false,
      };
    case types.PARSE_FROM_XML_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg || messages.UNABLE_TO_PARSE_METADATA_URL_OR_XML,
        parseXmlInProgress: false,
      };
    case types.CLEAR_IMPORT_URL:
      return {
        ...state,
        importMetadata: null,
        showModalImportUrl: false,
        duplicate: null,
      };
    case types.UPDATE_APPLICATION_START:
      return {
        ...state,
        errorMsg: null,
        updateAppInProgress: true
      };
    case types.UPDATE_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        updateAppInProgress: false
      };
    case types.UPDATE_APPLICATION_FAIL:
      return {
        ...state,
        errorMsg: state.applicationName + messages.APP_NAME_IS_DUPLICATED,
        updateAppInProgress: false
      };

    case types.GET_APPLICATION_START:
      return {
        ...state,
        errorMsg: null,
        getAppInProgress: true
      };
    case types.GET_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        applicationId: action.metadata.id,
        importMetadata: action.metadata.spSaml2Metadata,
        downloadUrl: action.metadata.spSaml2Metadata.downloadUrl,
        idpUserAttributes: action.metadata.spSaml2Metadata.idpUserAttributes,
        applicationName: action.metadata.name,
        userFriendlyName: action.metadata.userFriendlyName,
        defaultSamlNameIdFormatEnum: action.metadata.spSaml2Metadata.defaultSamlNameIdFormatEnum,
        selectedImportOption: action.metadata.spSaml2Metadata.downloadUrl
            ? samlConstants.IMPORT_FROM_URL : samlConstants.IMPORT_FROM_FILE,
        getAppInProgress: false,
      };
    case types.GET_APPLICATION_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg,
        getAppInProgress: false
      };
    case types.DELETE_SP_START:
      return {
        ...state,
        errorMsg: null,
        deleteAppInProgress: true
      };
    case types.DELETE_SP_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        deleteAppInProgress: false
      };
    case types.DELETE_SP_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg,
        deleteAppInProgress: false
      };
    case types.DELETE_USER_ATTRIBUTE:
      return {
        ...state,
        idpUserAttributes: state.idpUserAttributes.filter(
            item => item !== action.targetAttribute)
      };

    case types.ADD_USER_ATTRIBUTE :
      return {
        ...state,
        idpUserAttributes: [...state.idpUserAttributes, action.newUserAttribute]
      };

    case types.UPDATE_USER_ATTRIBUTES:
      return {
        ...state,
        idpUserAttributes: state.idpUserAttributes.map((item, index) => {
          if (index.toString() !== action.payload.target.id.toString()) {
            return item
          }
          return {
            ...item,
            [action.payload.target.name]: action.payload.target.value,
          }
        })
      };
    case types.RECOVER_APPLICATION:
      return {
        ...state,
        errorMsg: null,
        applicationId: action.payload.id,
        importMetadata: action.payload.spSaml2Metadata,
        idpUserAttributes: action.payload.spSaml2Metadata.idpUserAttributes,
        applicationName: action.payload.name,
        userFriendlyName: action.payload.userFriendlyName,
        defaultSamlNameIdFormatEnum: action.payload.spSaml2Metadata.defaultSamlNameIdFormatEnum,
        downloadUrl: action.payload.spSaml2Metadata.downloadUrl,
        selectedImportOption: action.payload.spSaml2Metadata.downloadUrl
            ? samlConstants.IMPORT_FROM_URL : samlConstants.IMPORT_FROM_FILE,
        duplicate: null
      };
    case types.REPLACE_APPLICATION:
      return {
        ...state,
        errorMsg: null,
        applicationId: action.appId,
        defaultSamlNameIdFormatEnum: action.payload.samlNameIdFormats.filter(
            e => e.samlNameIdFormatEnum
                === state.defaultSamlNameIdFormatEnum).length
        > 0 ? state.defaultSamlNameIdFormatEnum
            : action.payload.defaultSamlNameIdFormatEnum,
        duplicate: null
      };
    case types.CLEAR_ERROR_MESSAGE:
      return {
        ...state,
        errorMsg: null
      };
    case types.UPDATE_APP_NAME:
      return {
        ...state,
        applicationName: action.payload
      };
    case types.UPDATE_USER_FRIENDLY_NAME:
      return {
        ...state,
        userFriendlyName: action.payload
      };
    case types.UPDATE_DEFAULT_NAME_ID:
      return {
        ...state,
        defaultSamlNameIdFormatEnum: action.payload
      };
    case types.UPDATE_DOWNLOAD_URL:
      return {
        ...state,
        downloadUrl: action.payload
      };

    case types.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMsg: action.errorMsg,
        successMsg: null
      };
    case types.CLEAR_MESSAGES:
      return {
        ...state,
        errorMsg: null,
        idpErrorMsg: null,
        successMsg: null
      };
    case types.ADD_SP_FAIL:
      return {
        ...state,
        errorMsg: state.applicationName + messages.APP_NAME_IS_DUPLICATED
      };
    case types.SHOW_IMPORT_MODAL:
      return {
        ...state,
        showImportModal: true,
      };
    case types.HIDE_IMPORT_MODAL:
      return {
        ...state,
        showImportModal: false,
      };
    case types.SHOW_ALL_METADATA_MODAL:
      return {
        ...state,
        showModalViewAllMetadata: true,
      };
    case types.HIDE_ALL_METADATA_MODAL:
      return {
        ...state,
        showModalViewAllMetadata: false,
      };
    case types.SHOW_EXPIRED_METADATA_CERTIFICATE_MODAL:
      return {
        ...state,
        modalExpiredMetadataCertificateIsShown: true
      };
    case types.HIDE_EXPIRED_METADATA_CERTIFICATE_MODAL:
      return {
        ...state,
        modalExpiredMetadataCertificateIsShown: false
      };

    case types.CHANGE_SELECTED_IMPORT_OPTION:
      return {
        ...state,
        selectedImportOption: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sp.js